module.exports = __webpack_public_path__ + "img/Pista_0624.995c1285.png";